/**
 * @format
 */

import * as actionTypes from './actionTypes';
import { Dispatch } from 'redux';

interface Subpoint {
	key: string;
	value: any;
}

export function processDecisionSupportSubpoints(subpoints: Subpoint[], endedInGuidedResponse: boolean) {
	return async function (dispatch: Dispatch, getState: () => any) {
		await dispatch(processDecisionSupportSubpointsAction(subpoints, endedInGuidedResponse));
		const state = getState();
		return Promise.resolve({
			activeCareOrder: state.careOrder,
			decisionSupportOutput: state.decisionSupport,
			availabilitySearchConfig: state.config.availabilitySearch,
			patientDetails: state.activePatient.details,
			routePrefix: state.config.instance.routePrefix,
		});
	};
}

function processDecisionSupportSubpointsAction(subpoints: Subpoint[], endedInGuidedResponse: boolean) {
	return {
		type: actionTypes.PROCESS_DECISION_SUPPORT_SUBPOINTS,
		subpoints: subpoints,
		endedInGuidedResponse: endedInGuidedResponse,
	};
}
